'use client';

import Image from 'next/image';
import Logo from '@public/webtrixLogoSBijelimTextom.svg';
import styles from './index.module.scss';
import { useLocale, useTranslations } from 'next-intl';
import { getPathname, Link } from '@/i18n/routing';

const Footer = () => {
  const t = useTranslations('footer');
  const locale = useLocale();
  const homePath = `/${locale}/`; // Adjust the homepage path based on locale

  return (
    <footer className={styles.container}>
      <div className={styles.content}>
        <Image src={Logo} alt="logo" width={80} height={80} />
        <ul className={styles.navLinks}>
          <li>
            <Link href={`${homePath}#services`}>{t('services')}</Link>
          </li>
          <li>
            <Link href={`${homePath}#about`}>{t('about')}</Link>
          </li>
          <li>
            <Link href={`${homePath}#approach`}>{t('approach')}</Link>
          </li>
          <li>
            <Link href={`${homePath}#skills`}>{t('technology')}</Link>
          </li>
          <li>
            <Link href={`${homePath}#contact`}>{t('getInTouch')}</Link>
          </li>

          <li>
            <Link
              href={getPathname({ href: `/${locale}/privacy-policy`, locale })}
            >
              {t('privacyPolicy')}
            </Link>
          </li>
          <li>
            <Link
              href={getPathname({ href: `/${locale}/terms-of-use`, locale })}
            >
              {t('termsOfUse')}
            </Link>
          </li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
